<canvas class="blur_bg" [id]="'bg_'+part.pId"  *ngIf="part.has_blur_bg"></canvas>
<div #box class="resizable-draggable no-select-text" 
    [class.cropOn]="part.crop_on"
    [style.width.px]="part.rd.width" 
    [style.height.px]="part.rd.height" 
    [style.left.px]="part.rd.left" 
    [style.top.px]="part.rd.top" 
    [style.transform]="'rotate(' + part.rd.deg + 'deg)'"
    [class.active]="status === 1 || status === 2 || status === 3"
    (mousedown)="part.crop_on ? setStatus($event, 2) : null"
    (window:mouseup)="part.crop_on ? setStatus($event, 0) : null"
>
    <div *ngIf="part.crop_on" class="resize-action" (mousedown)="setStatus($event, 1)"></div>
    
    <div #rotate class="rotate-action" [ngClass]="{'not-show': !part.crop_on}" (mousedown)="setStatus($event, 3)"></div>

    <ng-container *ngIf="part.type == 'image'; else elseTemplateIsImageSource">
        <img style="max-width: 100%; max-height: 100%;"     
        [id]="'img_'+part.pId" draggable="false" class="no-drag-img"
        height="100%" 
        width="100%"  [ngStyle]="part?.video_filters_on ? {
            'filter': 'brightness(' + part?.video_filters?.brightness + ') ' +
                'contrast(' + cssContrast(part) + '%) ' +
                'saturate(' + part?.video_filters?.saturation + '%) ' +
                'grayscale(' + part?.video_filters?.grayscale + '%) ' +
                'hue-rotate(' + part?.video_filters?.hue + 'deg)',
            'opacity': part.opacity || 1
          } : {'filter': 'unset', 'opacity': part.opacity || 1}" [src]="host + part.original + '?company_id=' + company_id">
    </ng-container>
    <ng-template #elseTemplateIsImageSource>        
        <video 
        [ngStyle]="part?.video_filters_on ? {
            'filter': 'brightness(' + part?.video_filters?.brightness + ') ' +
                'contrast(' + cssContrast(part) + '%) ' +
                'saturate(' + part?.video_filters?.saturation + '%) ' +
                'grayscale(' + part?.video_filters?.grayscale + '%) ' +
                'hue-rotate(' + part?.video_filters?.hue + 'deg)'
          } : {'filter': 'unset'}"
        #video 
        height="100%" 
        width="100%" 
        [id]="'video_'+part.pId" 
        class="player" 
        [src]="!!part?.blobSrc ? part?.blobSrc : (host + (part?.preview1080 ? part?.preview1080 : part?.original) + '?company_id=' + company_id)"
        (loadedmetadata)="loadedVideo($event)" 
        (timeupdate)="loadBlurBg($event)"
        >
            Your browser doesn't support HTML5 video tag.
        </video>
        <div class="curr_time" (click)="log()">{{video?.currentTime | veTime}}</div>
    </ng-template>
    <div [ngClass]="{'not-show': !part.rd.deg}" class="black_sq" #black_sq [style.transform]="'rotate(' + -(part.rd.deg) + 'deg)'" [style.left.px]="-(max_side - part.rd.width)/2" [style.top.px]="-(max_side - part.rd.height)/2" [style.width.px]="max_side" [style.height.px]="max_side"></div>      
</div>


<div class="magnet-lines-container" *ngIf="status === 1 || status === 2">
  <div class="magnet-line v wcenter" [ngClass]="{'active': isMagnetActive.centerV}"></div>
  <div class="magnet-line h hcenter" [ngClass]="{'active': isMagnetActive.centerH}"></div>
  <div class="magnet-line h top" [ngClass]="{'active': isMagnetActive.top}"></div>
  <div class="magnet-line h bottom" [ngClass]="{'active': isMagnetActive.bottom}"></div>
  <div class="magnet-line v left" [ngClass]="{'active': isMagnetActive.left}"></div>
  <div class="magnet-line v right" [ngClass]="{'active': isMagnetActive.right}"></div>
</div>